<template>
  <div>
    <!-- <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>-->
    <!-- <div class="mainTitle">题型管理</div> -->
    <el-card class="box-card" style="margin-top: 0px;">
      <el-row :span="24">
        <el-col :span="12" class="button-Array">
          <el-button
            v-auth="'/questionType/addQuestionType'"
            style="border-top-right-radius:0px;border-bottom-right-radius:0px;"
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
          >新增</el-button>
          <!-- <el-button
            style="border-radius:0px;background:rgb(24,200,168);border-color:rgb(24,200,168)"
            type="danger"
            @click="batchDeleteQuestionType"
            icon="el-icon-minus"
          >批量删除</el-button>
          <el-button
            style="border-radius:0px;background:rgb(251,149,82);border-color:rgb(251,149,82)"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
          >导入</el-button>
          <el-button
            style="border-top-left-radius:0px !important;border-bottom-left-radius:0px !important;"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
          >导出</el-button>-->
        </el-col>
        <!-- <el-col style="text-align: right" :span="12">
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
          >导出</el-button>
        </el-col>-->
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        v-loading="Loading"
        border
        @selection-change="selectionChange"
      >
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip width="80" align="center" prop="sort" label="排序"></el-table-column>
        <el-table-column show-overflow-tooltip width="80" align="center" prop="mode" label="模式"></el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="name" label="题型名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="big" width="200" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.big==1">大题</span>
            <span v-else>小题、常规题</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
        <el-table-column prop label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                v-auth="'/questionType/updateQuestionType'"
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click="selection = scope.row.id;getQuestionType()"
              ></i>

              <!-- <span style="width:100%" @click="selection = scope.row.id, editFormVisible = true">编辑</span> -->
              <!-- <span @click="deleteQuestionType(scope.row)">删除</span> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!Loading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加题型" :visible.sync="addFormVisible" width="30%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-form-item label="题型名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入题型名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="大题" prop="big">
          <el-radio-group v-model="addForm.big">
            <el-radio label="1">是</el-radio>
            <el-radio label="-1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模式" prop="mode" v-if="addForm.big!=1">
          <el-radio-group v-model="addForm.mode">
            <el-radio label="填写">填写</el-radio>
            <el-radio label="单选">单选</el-radio>
            <el-radio label="多选">多选</el-radio>
            <el-radio label="判断">判断</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="显示排序" prop="sort">
          <el-input
            type="number"
            v-model="addForm.sort"
            placeholder="请输入显示排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="3"
            v-model="addForm.remark"
            placeholder="请输入备注"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addQuestionType">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑题型" :visible.sync="editFormVisible" width="30%" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="题型名称" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入题型名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="大题" prop="big">
          <el-radio-group v-model="editForm.big">
            <el-radio label="1">是</el-radio>
            <el-radio label="-1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模式" prop="mode" v-if="editForm.big!=1">
          <el-radio-group v-model="editForm.mode">
            <el-radio label="填写">填写</el-radio>
            <el-radio label="单选">单选</el-radio>
            <el-radio label="多选">多选</el-radio>
            <el-radio label="判断">判断</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="显示排序" prop="sort">
          <el-input
            type="number"
            v-model="editForm.sort"
            placeholder="请输入显示排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="3"
            v-model="editForm.remark"
            placeholder="请输入备注"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateQuestionType">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="name" label="题型名称"></el-table-column>
        <el-table-column prop="mode" label="展示模式">
          <template slot-scope="scope">
            <span v-if="scope.row.mode==1">填写模式</span>
            <span v-else>选项模式</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 20,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      Loading: false,
      searchForm: {},
      addForm: {
        name: "",
        mode: "",
        remark: "",
        big: ""
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字"
          }
        ],
        mode: [
          {
            required: true,
            message: "请选择模式",
            trigger: "blur"
          }
        ],
        big: [
          {
            required: true,
            message: "请选择大题",
            trigger: "blur"
          }
        ],
        remark: [],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      editForm: {
        name: "",
        mode: "",
        remark: "",
        big: ""
      },
      editFormRules: {
        big: [
          {
            required: true,
            message: "请选择大题",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字"
          }
        ],
        mode: [
          {
            required: true,
            message: "请输入模式",
            trigger: "blur"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        remark: []
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],

      fileAction: `${process.env.BASE_URL}/questionType/upload`,
      fileList: [],
      loading: false
    };
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getQuestionType() {
      this.api.questionType
        .getQuestionType({
          id: this.selection
        })
        .then(result => {
          result.data.big = String(result.data.big);
          this.editForm = result.data;
          this.editFormVisible = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.Loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.questionType
        .pageList(this.searchForm)
        .then(result => {
          this.Loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addQuestionType() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.questionType
            .addQuestionType(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateQuestionType() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.questionType
            .updateQuestionType(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteQuestionType(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.questionType
            .deleteQuestionType([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteQuestionType() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.questionType
            .deleteQuestionType(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.questionType
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.questionType
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    "editForm.big": function(newVal) {
      console.log(1111, newVal);
      if (newVal == 1) {
        this.editFormRules.mode = [
          {
            required: false,
            message: "请选择模式",
            trigger: "blur"
          }
        ];
      } else {
        this.editFormRules.mode = [
          {
            required: true,
            message: "请选择模式",
            trigger: "blur"
          }
        ];
      }
    },
    "addForm.big": function(newVal) {
      if (newVal == 1) {
        this.addFormRules.mode = [
          {
            required: false,
            message: "请选择模式",
            trigger: "blur"
          }
        ];
      } else {
        this.addFormRules.mode = [
          {
            required: true,
            message: "请选择模式",
            trigger: "blur"
          }
        ];
      }
    },
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.addForm = {
          name: "",
          mode: "",
          remark: "",
          big: "1",
          mode: ""
        };
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
      }
    }
  },
  mounted() {
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/questionType/index.vue